// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Dates_swiper-slide-active__DUP6z","list":"Dates_list__5l0zc","item":"Dates_item__M3QcR","headline":"Dates_headline__sKxWP","date":"Dates_date__4ztaS"};